export default __webpack_public_path__ + "static/media/medical-checkup.8a2158cf.png";